import React from "react";
import { motion } from "framer-motion";
import AboutCard from "../../UI/About-Card/AboutCard";
import WhyNetwork from "../../UI/Why Networking/WhyNetwork";
import "./About.css";
import AboutImage from "../../../assets/gallery/i7.webp";
import Vision from "./AboutPages/Vision/Vision";
import TeamLead from "./AboutPages/Team-Lead/TeamLead";
import FounderImg from "../../../assets/ihn/team/founderimg.webp"
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


const About = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.2, ease: "easeOut" } }
  };
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 200); // offset for navbar animation
      }
    }
  }, [location]);

  return (
    <div className="page-content">

      {/* <div className="about-hero" >
        <img src={AboutImage} alt="About Banner" />
        <div className="overlay"></div>
        <motion.h1
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          className="about-head"
        >
          About Us
        </motion.h1>
      </div> */}

      {/* About Content Section */}
      <div className="about-content ">
        <section id="our-story" className="our-story-clean container mb-5">
          <div className="story-wrapper">
            <motion.div
              className="story-header"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <span className="story-tag">Established 2019</span>
              <h1 className="heading">
                Our Story
              </h1>
            </motion.div>

            <motion.div
              className="story-body story-card"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="story-content">
                <p>
                  Indian Hospitality Network (IHN) was conceived with a clear purpose — to
                  create a unified ecosystem where professionals across hospitality,
                  travel, tourism, and allied industries can meaningfully connect,
                  collaborate, and grow.
                </p>

                <p>
                  What began as an idea to bridge gaps between industries has evolved into
                  a one-of-a-kind membership platform offering specialised concierge-led
                  engagement. IHN brings together decision-makers, innovators, and brands
                  across the global hospitality and tourism ecosystem.
                </p>

                <p>
                  At its core, IHN exists to foster authentic relationships — beyond
                  transactional networking. Through curated engagements and bespoke
                  interactions, members unlock new opportunities and lasting
                  partnerships.
                </p>

                <p>
                  IHN is not just a network; it is a collaborative platform designed to
                  drive sustained growth, shared success, and long-term credibility in an
                  increasingly interconnected world.
                </p>
              </div>
              
            </motion.div>
              
          </div>
        </section>


        <motion.div
          className="about-intro"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        // variants={fadeInUp}
        >
          <section id="why-ihn" className="why-ihn-section fade-in">
            <div className="container">
              <div className="why-ihn-panel">
                <div className="why-ihn-accent"></div>

                <div className="why-ihn-content">
                  <h1 className="heading">Why IHN?</h1>

                  <p className="why-ihn-text">
                    IHN has been thoughtfully conceptualised as a one-of-a-kind Membership
                    Platform offering specialised concierge services connecting
                    professionals across corporate, hospitality, travel, tourism, and
                    allied industries.
                  </p>

                  <p className="why-ihn-text">
                    Our ecosystem spans hotels, resorts, clubs, homestays, restaurants,
                    airlines, tourism boards, cruise liners, visitor attractions, theme
                    parks, cinemas, malls, entertainment, conferences, exhibitions,
                    events, weddings, corporate agents, travel operators, DMCs, skilling
                    units, and affiliated partners worldwide.
                  </p>

                  <p className="why-ihn-text">
                    Through meaningful engagement, bespoke events, and curated
                    interactions, IHN enables authentic collaboration that drives
                    sustained growth and global credibility.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </motion.div>

        <motion.div
          className="mt-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        // variants={fadeInUp}
        >
          <Vision />
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h1 className=" text-center mt-5 heading">
            Our Leadership
          </h1>
          <motion.div
            className="mt-5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          // variants={fadeInUp}
          >
            <TeamLead />
          </motion.div>
        </motion.div>

      </div>
    </div>
  );
};

export default About;



